import ApplicationsAccordion from 'components/ApplicationsAccordion';
import DetailsViewCardHeader from 'components/DetailsViewCardHeader';
import DetailsViewEntityMenu from 'components/DetailsViewEntityMenu';
import DetailsViewPageContainer from 'components/DetailsViewPageContainer';
import LinkedEntitiesAccordion from 'components/LinkedEntitiesAccordion';
import UpdateClientForm from 'components/forms/UpdateClientForm';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { CARD_HEADER_DETAIL_TYPE, DETAIL_TYPE_FARM, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const ClientsDetailsPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const {
        applications,
        currentClient,
        dropdownMenuItems,
        entitiesLink,
        farmMenuItems,
        handleClose,
        handleEditClose,
        handleFarmNext,
        handleSelectApplication,
        handleToggleApplications,
        handleToggleLinkedEntities,
        isApplicationsLoading,
        isApplicationsOpen,
        isClientLoading,
        isClosing,
        isEditing,
        isFarmsLoading,
        isLinkedEntitiesOpen,
        selectedApplicationId,
        selectedBoundaryGeometry,
        setIsClosing,
        totalFarmsCount
    } = useData();

    const { APPLICATIONS, LINKED_ENTITIES } = useTranslation();

    return (
        <DetailsViewPageContainer
            geometry={selectedBoundaryGeometry}
            handleClose={handleClose}
            testId={testId}>
            <DetailsViewCardHeader
                detailType={CARD_HEADER_DETAIL_TYPE}
                isDisabled={isEditing}
                isLoading={isClientLoading}
                items={dropdownMenuItems}
                name={currentClient?.name ?? ''}
            />

            {isEditing ? (
                <UpdateClientForm
                    formValues={currentClient}
                    isClosing={isClosing}
                    onClose={handleEditClose}
                    setIsClosing={setIsClosing}
                />
            ) : (
                <>
                    <LinkedEntitiesAccordion
                        entitiesLink={entitiesLink}
                        isOpen={isLinkedEntitiesOpen}
                        label={LINKED_ENTITIES}
                        onToggle={handleToggleLinkedEntities}>
                        <DetailsViewEntityMenu
                            entityType={DETAIL_TYPE_FARM}
                            isLoading={isFarmsLoading}
                            items={farmMenuItems}
                            onNext={handleFarmNext}
                            totalCount={totalFarmsCount}
                        />
                    </LinkedEntitiesAccordion>

                    <ApplicationsAccordion
                        applications={applications}
                        isLoading={isApplicationsLoading}
                        isOpen={isApplicationsOpen}
                        label={APPLICATIONS}
                        onSelectApplication={handleSelectApplication}
                        onToggle={handleToggleApplications}
                        selectedApplicationId={selectedApplicationId}
                    />
                </>
            )}
        </DetailsViewPageContainer>
    );
};

export default ClientsDetailsPage;
